'use client'

import { useEffect } from 'react'

export const ContentfulRawHtmlScripts = ({ scriptTexts }: { scriptTexts: string[] }) => {
  useEffect(() => {
    scriptTexts.forEach(text => {
      const node = document.createElement('script')
      node.innerText = text
      document.body.appendChild(node)
    })
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
